import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const KisiContext = createContext()

const KisiProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllKisiLocks = async (filter) => {
        try {
            const { page, search, limit } = filter

            let { data } = await axios.get(`${baseURL}/admin/kisi/locks?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}`, { headers })            
            
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const syncKisiLocksData = async () => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/kisi/locks/sync`, { headers })
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: 'An error occurred. Please try again later.', position: 'top', status: 'error', isClosable: true });
        }
    }

    const syncKisiLocationData = async () => {
        try {
            const { data } = await axios.post(`${baseURL}/admin/kisi/location/sync`, { headers })
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: 'An error occurred. Please try again later.', position: 'top', status: 'error', isClosable: true });
        }
    }

    return (
        <KisiContext.Provider value={{ getAllKisiLocks, syncKisiLocksData, syncKisiLocationData }}>
            {children}
        </KisiContext.Provider>
    )
}

const useKisi = () => useContext(KisiContext)

export { useKisi, KisiProvider }